export default "__VITE_ASSET__CBAwPoAf__"